import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-api-interaction-info',
  templateUrl: './api-interaction-info.component.html',
  styleUrls: ['./api-interaction-info.component.scss']
})
export class ApiInteractionInfoComponent implements OnInit {

  @Input() public data: any = null;

  constructor() { }

  public ngOnInit() {
  }

}
